import { render } from "./ChatContent.vue?vue&type=template&id=0bb2f6d6&ts=true"
import script from "./ChatContent.vue?vue&type=script&lang=ts"
export * from "./ChatContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__